storefrontApp.controller("currencyConverterController", [
    "$document",
    "$rootScope",
    "$scope",
    "$timeout",
    "$window",
    "commonService",
    "configs",
    "modalService",
    function (
        $document,
        $rootScope,
        $scope,
        $timeout,
        $window,
        commonService,
        configs,
        modalService
    ) {
        //#region Fields

        //#region Currency Conversion
        var autoCurrencyConversionCookieName = _.get(configs, [
            "autoCurrencyConversionCookieName",
        ]);
        var autoCurrencyConversionIterations = 0;
        var autoCurrencyConversionTimer = 500;
        $rootScope.currencyConversion = {
            displayCurrency: null,
            excludedUrls: _.get(configs, ["currencyConverterExcludedUrls"], []),
            localCurrency: null,
            redirectUrl: null,
            storeCurrency: null,
        };
        //#endregion

        //#endregion

        //#region Events

        //#region Currency Conversion
        $rootScope.$on("RefreshCurrencyConversion", function (_event, timeout) {
            refreshCurrencyConversion(timeout);
        });
        //#endregion

        //#endregion

        //#region Functions

        //#region Currency Conversion
        $scope.currencyConverterExitConfirmed = function () {
            modalService.close("confirmCurrencyConverterExit");
            $window.location.href = $rootScope.currencyConversion.redirectUrl;
        };

        $scope.toggleCurrency = function () {
            var targetCurrency =
                $rootScope.currencyConversion.displayCurrency ==
                $rootScope.currencyConversion.storeCurrency
                    ? $rootScope.currencyConversion.localCurrency
                    : $rootScope.currencyConversion.storeCurrency;

            convertCurrencies(
                $rootScope.currencyConversion.displayCurrency,
                targetCurrency
            );

            $rootScope.currencyConversion.displayCurrency = targetCurrency;
            commonService.setCookie(
                autoCurrencyConversionCookieName,
                $rootScope.currencyConversion.displayCurrency ==
                    $rootScope.currencyConversion.localCurrency,
                365
            );
        };

        //#region Private Functions
        function checkAutoCurrencyConversion() {
            $rootScope.currencyConversion.localCurrency &&
                commonService.getCookie(autoCurrencyConversionCookieName) ==
                    "true" &&
                $timeout(function () {
                    if (autoCurrencyConversionIterations == 0)
                        $scope.toggleCurrency();
                    else refreshCurrencyConversion();

                    autoCurrencyConversionTimer =
                        autoCurrencyConversionTimer * 2;
                    autoCurrencyConversionIterations++;

                    if (autoCurrencyConversionIterations <= 3)
                        checkAutoCurrencyConversion();
                }, autoCurrencyConversionTimer);
        }

        function convertCurrencies(sourceCurrency, targetCurrency) {
            sourceCurrency.symbol.match(
                new RegExp("^[" + targetCurrency.regexSymbol + "]+$")
            ) && convertCurrencies(targetCurrency, sourceCurrency);

            commonService
                .getHTMLTextNodes($document[0].body)
                .forEach(function (node) {
                    node.data = node.data.replace(
                        new RegExp(
                            "(" +
                                sourceCurrency.regexSymbol +
                                ")([0-9]*)((\\,[0-9]*)?)*(\\.[0-9][0-9])+",
                            "g"
                        ),
                        function (money) {
                            var oldPrice = parseFloat(
                                money
                                    .substring(
                                        Number(sourceCurrency.symbol.length)
                                    )
                                    .replace(/,/g, "")
                            );
                            return (
                                targetCurrency.symbol +
                                commonService.formatMoney(
                                    targetCurrency ==
                                        $rootScope.currencyConversion
                                            .localCurrency
                                        ? oldPrice *
                                              $rootScope.currencyConversion
                                                  .localCurrency.exchangeRate
                                        : oldPrice /
                                              $rootScope.currencyConversion
                                                  .localCurrency.exchangeRate,
                                    2,
                                    ".",
                                    ","
                                )
                            );
                        }
                    );
                });
        }

        function initializeCurrencyConversion() {
            commonService.getStoreAndLocalCurrency().then(function (response) {
                var cc =
                    _.get(response, ["data", "countryCode"], "") || "";
                window.__storefrontCountryCode = cc;
                $rootScope.$emit("CountryCodeCookieSet", cc);
                document.dispatchEvent(
                    new CustomEvent("CountryCodeCookieSet", {
                        detail: { countryCode: cc },
                    })
                );
                if (
                    (cc || "").toUpperCase() != "US" &&
                    !_.some(
                        $rootScope.currencyConversion.excludedUrls,
                        function (url) {
                            if (url.indexOf("*") > -1) {
                                var urlArray = _.compact(url.split("/"));
                                var pathArray = _.compact(
                                    $window.location.pathname.split("/")
                                );
                                return (
                                    urlArray.length == pathArray.length &&
                                    _.every(urlArray, function (x, i) {
                                        return (
                                            x == "*" ||
                                            x.toLowerCase() ==
                                                pathArray[i].toLowerCase()
                                        );
                                    })
                                );
                            } else
                                return (
                                    $window.location.pathname.toLowerCase() ==
                                        url.toLowerCase() ||
                                    $window.location.pathname.toLowerCase() ==
                                        url.toLowerCase() + "/"
                                );
                        }
                    )
                ) {
                    $rootScope.currencyConversion.displayCurrency =
                        $rootScope.currencyConversion.storeCurrency = _.get(
                            response,
                            ["data", "storeCurrency"]
                        );
                    $rootScope.currencyConversion.localCurrency = _.get(
                        response,
                        ["data", "localCurrency"]
                    );
                    checkAutoCurrencyConversion();
                }
            });
        }
        initializeCurrencyConversion();

        function refreshCurrencyConversion(timeout) {
            $rootScope.currencyConversion.localCurrency &&
                $timeout(function () {
                    convertCurrencies(
                        $rootScope.currencyConversion.displayCurrency ==
                            $rootScope.currencyConversion.storeCurrency
                            ? $rootScope.currencyConversion.localCurrency
                            : $rootScope.currencyConversion.storeCurrency,
                        $rootScope.currencyConversion.displayCurrency
                    );
                }, timeout || 0);
        }
        //#endregion

        //#endregion

        //#endregion
    },
]);
